/*
 * MyRatna — Collection Reviews: behaviour only.
 *
 * The product section is identical bar its CSS prefix; see product-reviews.js.
 */
(function () {
  'use strict';

  var P = 'crv'; // CSS/data prefix: crv = collection, rr = product

  function init(root) {
    if (root.dataset.reviewsInit) return;
    root.dataset.reviewsInit = '1';

    var helpfulUrl = (root.dataset.helpfulUrl || '').trim();
    var track = root.querySelector('[data-' + P + '-track]');
    var prev = root.querySelector('[data-' + P + '-prev]');
    var next = root.querySelector('[data-' + P + '-next]');
    var dots = root.querySelector('[data-' + P + '-dots]');
    var lb = root.querySelector('[data-' + P + '-lightbox]');
    var lbImg = root.querySelector('[data-' + P + '-lb-img]');
    var lbCounter = root.querySelector('[data-' + P + '-lb-counter]');
    if (!track) return;

    /* ===== Carousel ===== */

    function cardStep() {
      var first = track.querySelector('.' + P + '-card');
      if (!first) return track.clientWidth * 0.9;
      var gap = parseFloat(getComputedStyle(track).columnGap || '18') || 18;
      return first.getBoundingClientRect().width + gap;
    }
    function perView() {
      return Math.max(1, Math.round(track.clientWidth / cardStep()));
    }
    function pageCount() {
      return Math.max(1, Math.ceil(track.querySelectorAll('.' + P + '-card').length / perView()));
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }
    function updateDots() {
      if (!dots || dots.hidden) return;
      var buttons = dots.children;
      var pages = buttons.length;
      var max = track.scrollWidth - track.clientWidth;
      var active = max > 0 ? Math.round((track.scrollLeft / max) * (pages - 1)) : 0;
      active = Math.min(pages - 1, Math.max(0, active));
      for (var i = 0; i < pages; i++) {
        var on = i === active;
        buttons[i].classList.toggle('is-active', on);
        buttons[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }
    function buildDots() {
      if (!dots) return;
      var pages = pageCount();
      dots.innerHTML = '';
      if (pages <= 1) {
        dots.hidden = true;
        return;
      }
      dots.hidden = false;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = P + '-dot';
        b.setAttribute('aria-label', 'Go to review set ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () {
            var max = track.scrollWidth - track.clientWidth;
            track.scrollTo({ left: pages > 1 ? (idx / (pages - 1)) * max : 0, behavior: 'smooth' });
          });
        })(i);
        dots.appendChild(b);
      }
      updateDots();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -perView() * cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: perView() * cardStep(), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          updateArrows();
          updateDots();
        });
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      if (!root.isConnected) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateArrows();
        buildDots();
      }, 150);
    });

    updateArrows();
    buildDots();

    // Review photos are lazy-loaded, so the track's scrollWidth — and with it the
    // arrows and the number of dots — settles only once they are in.
    window.addEventListener('load', function () {
      if (!root.isConnected) return;
      updateArrows();
      buildDots();
    });

    /* ===== Helpful / Not helpful votes =====
       The tallies rendered above come from the metafield, so they are as of the last CRM
       sync; a click posts to the CRM and then shows the tallies it answers with. A
       visitor holds at most one verdict: clicking the other switches (the CRM moves both
       counts in that one call), clicking the one they hold takes it back. Which one they
       hold lives in this browser, under the same keys the reviews page uses. */

    var VOTE_KEYS = { helpful: 'rvp-helpful-', not_helpful: 'rvp-not-helpful-' };

    function storedVote(id) {
      try {
        for (var vote in VOTE_KEYS) {
          if (localStorage.getItem(VOTE_KEYS[vote] + id) === '1') return vote;
        }
      } catch (e) {} // Private mode, or storage turned off: the buttons still work.
      return 'none';
    }
    function storeVote(id, vote) {
      try {
        for (var key in VOTE_KEYS) {
          if (key === vote) localStorage.setItem(VOTE_KEYS[key] + id, '1');
          else localStorage.removeItem(VOTE_KEYS[key] + id);
        }
      } catch (e) {}
    }

    Array.prototype.forEach.call(root.querySelectorAll('.' + P + '-card'), function (card) {
      var id = parseInt(card.dataset.reviewId, 10) || 0;
      var buttons = card.querySelectorAll('[data-vote]');
      if (!id || !buttons.length) return;

      var counts = {};
      Array.prototype.forEach.call(card.querySelectorAll('[data-vote-count]'), function (el) {
        counts[el.dataset.voteCount] = el;
      });

      var held = storedVote(id);
      var busy = false;

      // Which button reads as pressed. 'none' leaves both unpressed.
      function paint(vote) {
        Array.prototype.forEach.call(buttons, function (b) {
          var on = b.dataset.vote === vote;
          b.classList.toggle('is-voted', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      // Nudge one tally. 'none' has no counter, so withdrawing is a no-op here.
      function tally(vote, delta) {
        var el = counts[vote];
        if (!el) return;
        el.textContent = Math.max(0, (parseInt(el.textContent, 10) || 0) + delta);
      }
      function setBusy(on) {
        busy = on;
        Array.prototype.forEach.call(buttons, function (b) {
          b.disabled = on;
        });
      }

      paint(held);

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          if (!helpfulUrl || busy) return;

          var previous = held;
          var vote = button.dataset.vote === previous ? 'none' : button.dataset.vote;

          setBusy(true);

          // Optimistic, so the card answers the click at once; the tallies the CRM
          // returns replace these a moment later, and a failure puts them back.
          tally(previous, -1);
          tally(vote, 1);
          paint(vote);

          fetch(helpfulUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: id, vote: vote, previous: previous }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            })
            .then(function (j) {
              if (!j || j.ok === false) throw new Error('vote rejected');
              if (typeof j.helpful === 'number' && counts.helpful) counts.helpful.textContent = j.helpful;
              if (typeof j.not_helpful === 'number' && counts.not_helpful) {
                counts.not_helpful.textContent = j.not_helpful;
              }
              held = vote;
              storeVote(id, vote);
              setBusy(false);
            })
            .catch(function (err) {
              console.error('[ratna-reviews]', err);
              tally(vote, -1);
              tally(previous, 1);
              paint(previous);
              setBusy(false);
            });
        });
      });
    });

    /* ===== Lightbox ===== */

    if (!lb || !lbImg) return;

    var state = { images: [], index: 0, lastFocus: null };

    function render() {
      var n = state.images.length;
      lbImg.src = state.images[state.index] || '';
      lbImg.alt = 'Review photo ' + (state.index + 1) + ' of ' + n;
      if (lbCounter) lbCounter.textContent = n > 1 ? state.index + 1 + ' / ' + n : '';
    }
    function open(images, trigger) {
      if (!images.length) return;
      state.images = images;
      state.index = 0;
      state.lastFocus = trigger || null;
      lb.toggleAttribute('data-single', images.length < 2);
      render();
      lb.hidden = false;
      void lb.offsetWidth; // let the transition run from the hidden state
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = lb.querySelector('[data-' + P + '-lb-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      if (lb.hidden) return;
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () {
        lb.hidden = true;
        lbImg.src = '';
        lb.removeEventListener('transitionend', done);
      };
      lb.addEventListener('transitionend', done);
      setTimeout(function () {
        if (!lb.hidden) done();
      }, 300);
      if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
    }
    function step(dir) {
      var n = state.images.length;
      if (n < 2) return;
      state.index = (state.index + dir + n) % n;
      render();
    }

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest ? e.target.closest('[data-review-images]') : null;
      if (!thumb || !root.contains(thumb)) return;

      var images;
      try {
        images = JSON.parse(thumb.dataset.reviewImages || '[]');
      } catch (err) {
        return; // Unreadable list: let the link open the photo on its own.
      }
      if (!Array.isArray(images) || !images.length) return;

      e.preventDefault();
      open(images, thumb);
    });

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-' + P + '-lb-close]')) return close();
      if (e.target.closest('[data-' + P + '-lb-prev]')) return step(-1);
      if (e.target.closest('[data-' + P + '-lb-next]')) return step(1);
      if (e.target !== lbImg) close();
    });

    // Document-level, so it must ignore a section the editor has since replaced.
    document.addEventListener('keydown', function (e) {
      if (!root.isConnected || lb.hidden) return;
      if (e.key === 'Escape') return close();
      if (e.key === 'ArrowLeft') return step(-1);
      if (e.key === 'ArrowRight') return step(1);
      if (e.key !== 'Tab') return;

      // Keep focus inside the dialog while it is open.
      var buttons = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) {
        return b.offsetParent !== null;
      });
      if (!buttons.length) return;
      var first = buttons[0];
      var last = buttons[buttons.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-' + P + ']'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', start);
})();